import FooterCommon from './FooterCommon.jsx';

export default function FooterCoffee() {
  return <FooterCommon />;
}
